import { Identifier } from "@/types/domain";
import { ContributorController } from "@features/contributors/controllers/contributor-controller";
import type { ContributorViewTabType } from "@features/contributors/ui/contributor/tabs.types";

export type ContributorPanelOptions = {
  initialSelectedTab?: ContributorViewTabType;
  activityMemberMetadata?: Record<string, string>;
};

export function buildContributorPanelContent(
  contributorId: Identifier,
  options?: ContributorPanelOptions,
) {
  const initialSelectedTab = options?.initialSelectedTab ?? "contributor";

  return (
    <ContributorController
      key={`${String(contributorId)}:${initialSelectedTab}:${options?.activityMemberMetadata?.originalEmail ?? ""}`}
      contributorId={contributorId}
      embedded
      initialSelectedTab={initialSelectedTab}
      activityMemberMetadata={options?.activityMemberMetadata}
    />
  );
}
